export default "__VITE_PUBLIC_ASSET__25f042d6__"